var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgToggleLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.06667C5.91015 7.06667 3 10.1708 3 14C3 17.8292 5.91015 20.9333 9.5 20.9333H17.5C21.0899 20.9333 24 17.8292 24 14C24 10.1708 21.0899 7.06667 17.5 7.06667H9.5ZM2 14C2 9.58172 5.35786 6 9.5 6H17.5C21.6421 6 25 9.58172 25 14C25 18.4183 21.6421 22 17.5 22H9.5C5.35786 22 2 18.4183 2 14ZM9.5 11.3333C8.11929 11.3333 7 12.5272 7 14C7 15.4728 8.11929 16.6667 9.5 16.6667C10.8807 16.6667 12 15.4728 12 14C12 12.5272 10.8807 11.3333 9.5 11.3333ZM6 14C6 11.9381 7.567 10.2667 9.5 10.2667C11.433 10.2667 13 11.9381 13 14C13 16.0619 11.433 17.7333 9.5 17.7333C7.567 17.7333 6 16.0619 6 14Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToggleLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/toggle-left.ee6ca324.svg";
export { ForwardRef as ReactComponent };